import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { isOrganizationsEntityType } from "shared/pages/teams/helpers/prepareCustomSortingGridFilter";

export const getAuthorsIdsParam = (
  moderationType: ModerationType,
  teamId: string,
  mainTab: any,
  entityType?: string,
) => {
  if (moderationType !== ModerationType.Outer || !teamId) {
    return {}
  }

  const resolvedEntityType = entityType || mainTab?.entityType

  if (isOrganizationsEntityType(resolvedEntityType)) {
    return { authorIdsFromTeamIds: [teamId] }
  }

  const isTabWithProjects = mainTab?.filter?.projectsShortInfos?.length > 0
  const isTabWithManual = mainTab?.filter?.usingFilterOrManual === false

  return isTabWithProjects && isTabWithManual
    ? {}
    : { authorIdsFromTeamIds: [teamId] }
}
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { isOrganizationsEntityType } from "shared/pages/teams/helpers/prepareCustomSortingGridFilter";

export const getAuthorsIdsParam = (
  moderationType: ModerationType,
  teamId: string,
  mainTab: any,
  entityType?: string,
) => {
  if (moderationType !== ModerationType.Outer || !teamId) {
    return {}
  }

  const resolvedEntityType = entityType || mainTab?.entityType

  if (isOrganizationsEntityType(resolvedEntityType)) {
    return { authorIdsFromTeamIds: [teamId] }
  }

  const isTabWithProjects = mainTab?.filter?.projectsShortInfos?.length > 0
  const isTabWithManual = mainTab?.filter?.usingFilterOrManual === false

  return isTabWithProjects && isTabWithManual
    ? {}
    : { authorIdsFromTeamIds: [teamId] }
}
